export const dragDropEndTrackEvent = ({
	source,
	contentStatus,
	pageId,
	previousParentPageId,
	newParentPageId,
	previousSpaceId,
	newSpaceId,
	referrer,
	isLivePage,
	isOnEditRoute,
	instructionType,
	isAmnPage = false,
}: {
	source: string;
	contentStatus: string | null;
	pageId: string;
	previousParentPageId: string;
	newParentPageId: string;
	previousSpaceId: string | undefined | null;
	newSpaceId: string | undefined | null;
	referrer?: string;
	isLivePage?: boolean; //TODO optional for pageTree
	isOnEditRoute?: boolean;
	instructionType?: string;
	isAmnPage?: boolean;
}) => ({
	type: 'sendTrackEvent',
	data: {
		action: 'updated',
		source,
		containerType: 'space',
		containerId: previousSpaceId,
		objectType: 'page',
		objectId: pageId,
		actionSubject: 'page',
		attributes: {
			contentStatus: contentStatus ?? null,
			previousSpaceId,
			previousParentPageId,
			newSpaceId,
			newParentPageId,
			...(referrer ? { referrer } : undefined),
			isLivePage,
			isOnEditRoute,
			instructionType,
			isAmnPage,
		},
	},
});

export const dragStartUIEvent = () => ({
	type: 'sendUIEvent',
	data: {
		action: 'dragged',
		actionSubject: 'pageTree',
		source: 'viewPageScreen',
	},
});

export const dragEndUIEvent = (isValidTarget) => ({
	type: 'sendUIEvent',
	data: {
		action: 'dropped',
		actionSubject: 'pageTree',
		source: 'viewPageScreen',
		attributes: {
			isValidTarget,
		},
	},
});

export const undoClickUIEvent = () => ({
	type: 'sendUIEvent',
	data: {
		action: 'clicked',
		actionSubject: 'button',
		actionSubjectId: 'pageTreeDragDropUndo',
		source: 'viewPageScreen',
	},
});

export const undoShortcutUIEvent = () => ({
	type: 'sendUIEvent',
	data: {
		action: 'pressed',
		actionSubject: 'keyboardShortcut',
		actionSubjectId: 'pageTreeDragDropUndo',
		source: 'viewPageScreen',
	},
});

export const pageTreeUIAnalytics = (
	action,
	spaceId,
	isInDrawer,
	isNav4Enabled,
	status?,
	contentId?,
	contentType?,
	navdexPointType?,
	isOnEditRoute?,
	contentTreeSize?,
	spaceKey?,
) => {
	const event = {
		type: 'sendUIEvent',
		data: {
			containerType: 'space',
			containerId: spaceId,
			objectType: contentType ?? 'page',
			objectId: contentId ?? '',
			action,
			actionSubject: 'pageTree',
			source: isInDrawer ? 'pageTreeDrawer' : 'containerNavigation',
			attributes: {
				navigationLayer: 'container',
				navigationContainer: 'sidebar',
				spaceView: 'TREE',
				contentStatus: status ?? null, // status/contentStatus is used to distinguish published page vs draft when clicking on a page tree item
				isOnEditRoute,
				contentTreeSize,
				navVersion: isNav4Enabled ? '4' : '3',
				spaceKey,
			},
		},
	};
	if (navdexPointType) {
		event.data.attributes['navdexPointType'] = navdexPointType;
	}
	return event;
};

export const pageTreePaginationEvent = (spaceId?, pageCount?, source?, direction?) => ({
	type: 'sendUIEvent',
	data: {
		action: 'clicked',
		containerId: spaceId,
		actionSubject: 'button',
		actionSubjectId: 'showAllButton',
		source: source || 'containerNavigation',
		attributes: {
			pageCount,
			direction,
		},
	},
});

export const oneOnOnePagesDetectedEvent = (
	oneOnOnePagesCount: number,
	totalPagesCount: number,
	spaceId?: string,
) => ({
	type: 'sendTrackEvent',
	data: {
		action: 'OneOnOneTitlesShown',
		actionSubject: 'pageTree',
		actionSubjectId: 'OneOnOneTitles',
		source: 'containerNavigation',
		containerType: 'space',
		containerId: spaceId,
		attributes: {
			oneOnOnePagesCount,
			totalPagesCount,
		},
	},
});
